var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsEditRoundedWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.225 6.63125L11.0375 3.48125L12.0875 2.43125C12.375 2.14375 12.7283 2 13.1473 2C13.5658 2 13.9188 2.14375 14.2063 2.43125L15.2563 3.48125C15.5438 3.76875 15.6938 4.11575 15.7063 4.52225C15.7188 4.92825 15.5813 5.275 15.2938 5.5625L14.225 6.63125ZM2.75 15.6875C2.5375 15.6875 2.3595 15.6155 2.216 15.4715C2.072 15.328 2 15.15 2 14.9375V12.8187C2 12.7187 2.01875 12.622 2.05625 12.5285C2.09375 12.4345 2.15 12.35 2.225 12.275L9.95 4.55L13.1375 7.7375L5.4125 15.4625C5.3375 15.5375 5.25325 15.5937 5.15975 15.6312C5.06575 15.6687 4.96875 15.6875 4.86875 15.6875H2.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsEditRoundedWhite);
export default __webpack_public_path__ + "static/media/material-symbols_edit-rounded_white.d83fb45d31336e7ca94b61042b6a9a46.svg";
export { ForwardRef as ReactComponent };